import * as React from "react";
const SvgPlay20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "black"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4.5.654 18.83 10 4.5 19.346V.654Zm2 3.692v11.308L15.17 10 6.5 4.346Z",
      clipRule: "evenodd"
    })
  );
export default SvgPlay20Px;
